"use client";

import { useSearchParams } from "next/navigation";
import { useLocale, useTranslations } from "next-intl";
import { usePathname, useRouter } from "@/i18n/navigation";

function GlobeIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path d="M3.5 9h17M3.5 15h17M12 3c2.5 2.7 4 5.8 4 9s-1.5 6.3-4 9c-2.5-2.7-4-5.8-4-9s1.5-6.3 4-9Z" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

function ChevronDownIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="m7 10 5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function LocaleSwitcher() {
  const t = useTranslations("editor.locale");
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const query = searchParams.toString();
  const href = query ? `${pathname}?${query}` : pathname;

  return (
    <label className="editor-toolbar-chip relative">
      <span className="text-[#b477ff]">
        <GlobeIcon />
      </span>
      <select
        className="pr-6"
        value={locale}
        onChange={(event) => {
          const nextLocale = (event.target.value as "pl" | "en") ?? "pl";
          router.replace(href, { locale: nextLocale });
        }}
        aria-label={t("title")}
        title={t("title")}
      >
        <option value="pl">Polski</option>
        <option value="en">English</option>
      </select>
      <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#c5cee0]">
        <ChevronDownIcon />
      </span>
    </label>
  );
}
